export class Document {
    public documentName: string = '';
}
